export default __webpack_public_path__ + "static/media/timer-start.be8faa57.svg";